import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";
import AButton from "../../views/pages/manage/common/form-fields-mui/AButton";
import CrossIcon from  "../../assets/img/svg/svgComponents/CrossIcon"

// import { ignoreFilterItem } from '../constants';
import { getFilterCount } from '../../views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { getInputField } from 'components/AFilterForm/FormFields';
const FilterForm = ({ closePopup,
    dropdownData,
    globalFilter,
    setGlobalFilter,
    searchHandler,
    getFilterFormFields,
    initialForm,
    tabKey
}) => {

    const [filterForm, setFilterForm] = useState(initialForm);
    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value }));
    };

    useEffect(
        () => {
            setFilterForm({
                ...globalFilter,
            })
        },
        []
    );

    const handleApplyFilter = () => {
        const req = {

        }
        searchHandler({...globalFilter,...filterForm})
        setGlobalFilter((prev)=>({...prev,...filterForm}))
        closePopup()
    }
    const resetFilterForm = () => {
        setFilterForm(initialForm)
        searchHandler({...globalFilter,...initialForm})
        setGlobalFilter((prev)=>({...prev,...initialForm}))
    }

    return <>
        <Card className="mb-0 regular-body label-color"
            style={{ width: "500px", borderRadius: "12px" }}>
            <CardBody className="d-flex flex-column">
                <div className="mb-1 d-flex align-items-start justify-content-between">
                    <div className="regular-large-bold">Filters</div>
                    <span onClick={closePopup} className='cursor semi-bolder'><CrossIcon /></span>
                </div>

                <div className="d-flex flex-column gap-md">
           <Row> {getFilterFormFields(dropdownData,filterForm,tabKey)?.map(formField =><Col md={6}> {getInputField(formField, filterFormHandler, filterForm)}</Col>)}</Row>
                    <div className="mt-3 d-flex flex-row-reverse justify-content-between">
                        <AButton
                            variant="primary_filled"
                            className="button_remove_left_margin"
                            onClick={() => {
                                handleApplyFilter();
                            }}
                            disabled={!getFilterCount({ ...filterForm })}
                        >
                            Apply
                        </AButton>

                        {globalFilter?.appliedFilterCount > 0 && (
                            <AButton
                                variant="danger_filled"
                                className="button_remove_left_margin"
                                // updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                                onClick={resetFilterForm}
                            >
                                Reset
                            </AButton>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    </>
}
export default FilterForm;
